import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFrequentProduct,
  createProduct,
  deleteDrugs,
  deleteFrequentProduct,
  deleteProduct,
  setDrugList,
  setError,
  setFrequentProducts,
  setLoading,
  setProducts,
  setSearchDrugs,
  setSearchProducts,
  setSearchStoreProducts,
  setStoreProducts,
  setCustomProducts,
  setTagsList,
  setManufacturersList,
  addManufacturer,
  updateManufacturerInList,
  removeManufacturerFromList,
  setDrugManagementData,
  setDrugManagementLoading,
  setNRxDrugNames,
  updateProduct,
} from "../../Reducer/Product/ProductSlice";
import apiAxios from "../../../services/apiAxios";
import { setActiveTab } from "../../Reducer/Admin/PartnerSlice";
import toast from "react-hot-toast";

export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async ({ current_page, limit }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/product/all?page=${current_page}&limit=${limit}`
      );

      const { products, currentPage, totalItems, totalPages } = response?.data;

      dispatch(setProducts({ products, currentPage, totalItems, totalPages }));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const getAllProducts = createAsyncThunk(
  "product/searchProducts",
  async ({ current_page, PID, SID, tagIds }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/product/all?page=${current_page}&productId=${PID || ""}&storeId=${
          SID || ""
        }&tagIds=${tagIds || ""}`
      );

      const { products, currentPage, totalItems, totalPages } = response?.data;
      if (PID) {
        const product = response?.data?.products?.filter(
          (pro) => String(pro?.IID) === String(PID)
        );
        dispatch(setSearchProducts(product));
      }
      if (PID && !SID) {
      } else {
        dispatch(setStoreProducts(products));
      }
      dispatch(setProducts({ products, currentPage, totalItems, totalPages }));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const getAllSearchProducts = createAsyncThunk(
  "product/getAllSearchProducts",
  async ({ search, SID }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/product/all?search=${search}&storeId=${SID || ""}`
      );
      dispatch(setSearchStoreProducts(response?.data?.products));

      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const searchProduct = createAsyncThunk(
  "product/searchProduct",
  async ({ name, IID }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`api/product/search-product`, {
        search: name || IID || "",
      });
      let productData = Array.isArray(response?.data) ? response.data : [];
      if (productData.length > 0 && IID) {
        const exactMatch = productData.filter(
          (pro) => String(pro?.IID).trim().toLowerCase() === String(IID).trim().toLowerCase()
        );
        if (exactMatch.length > 0) {
          productData = exactMatch;
        }
      }
      dispatch(setSearchProducts(productData));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const addProduct = createAsyncThunk(
  "doctor/addProduct",
  async (product, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("/api/product/create", product);
      toast.success("Successfully added.");
      dispatch(createProduct(response?.data));
      // dispatch(fetchProducts({current_page:1,limit:10}));
      dispatch(setActiveTab("Stock"));
      dispatch(setActiveTab({ name: "Stock", index: 0 }));
      dispatch(setSearchProducts([]));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      // toast.error("Somethng went wrong !! please try after some time..");
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const modifyProduct = createAsyncThunk(
  "store/modifyProduct",
  async ({ productId, updatedData, role }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(
        `/api/product/update-product/${productId}`,
        updatedData
      );
      if (response?.status === 200) {
        try {
          const updatedProductData = response?.data?.product;
          dispatch(updateProduct({ productId, updatedData: updatedProductData }));
          if (updatedProductData) {
            dispatch(setSearchProducts([updatedProductData]));
          }
          dispatch(fetchProducts({ current_page: 1, limit: 10 }));
          toast.success("Product successfully edited");
        } catch (updateError) {
          console.error("Error in updateProduct dispatch:", updateError);
        }
        dispatch(setLoading(false));
      }
      return response;
    } catch (error) {
      // toast.error(error.message);
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const removeProduct = createAsyncThunk(
  "doctor/removeProduct",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.delete(`/api/product/delete-product/${id}`);
      if (response?.status === 200) {
        toast.success("Product deleted successfully");
        dispatch(deleteProduct(id));
        dispatch(setSearchProducts([]));
        const tabChangeEvent = new Event("tabChange");
        window.dispatchEvent(tabChangeEvent);
        dispatch(setActiveTab({ name: "Stock", index: 0 }));
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);
export const fetchProductsOfStore = createAsyncThunk(
  "product/fetchProductsOfStore",
  async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(`/api/store/get-products`);
      dispatch(setStoreProducts(response?.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);
export const fetchProductListOfStore = createAsyncThunk(
  "product/fetchProductListOfStore",
  async ({ page, limit, search, tagIds }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/store/get-store-products?page=${page}&limit=${limit}&search=${search || ""}&tagIds=${tagIds || ""}`
      );
      dispatch(setStoreProducts(response?.data));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);
export const searchProductListOfStore = createAsyncThunk(
  "product/fetchProductListOfStore",
  async ({ page, limit, search }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `api/store/get-store-products?page=${page}&limit=${limit}&search=${search}`
      );
      dispatch(setSearchStoreProducts(response?.data));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const fetchFrequentProducts = createAsyncThunk(
  "product/fetchFrequentProducts",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/doctor/get-products-frequent/${id}`
      );
      dispatch(setFrequentProducts(response?.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);
export const frequentProductList = createAsyncThunk(
  "product/frequentProductList",
  async (payload, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const id = payload?.id;
      const searchVal = payload?.productName !== undefined ? payload?.productName : (payload?.search !== undefined ? payload?.search : "");
      const response = await apiAxios.get(
        `/api/doctor/get-products-frequent-v1/${id}?search=${encodeURIComponent(searchVal || "")}`
      );
      dispatch(setFrequentProducts(response?.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const addFrequentProducts = createAsyncThunk(
  "doctor/addFrequentProducts",
  async (product, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      let productId = { IID: product?.product?.IID };
      const response = await apiAxios.post(
        "/api/doctor/add-products-frequent",
        productId
      );
      toast.success("Successfully added.");
      dispatch(createFrequentProduct(product));
      dispatch(setLoading(false));
      return response?.data;
    } catch (error) {
      const message = error.response?.data.error;
      toast.error(message);
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return rejectWithValue(
        error.response
          ? error.response?.data
          : { message: "Unknown error occurred" }
      );
    }
  }
);

export const removeFrequentProduct = createAsyncThunk(
  "doctor/removeFrequentProduct",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.delete(
        `api/doctor/remove-products-frequent/${id}`
      );
      if (response?.status === 200) {
        toast.success("Product deleted successfully");
        dispatch(deleteFrequentProduct(id));
        dispatch(setLoading(false));
        // const tabChangeEvent = new Event("tabChange");
        // window.dispatchEvent(tabChangeEvent);
        // dispatch(setActiveTab({ name: "Stock", index: 0 }));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const addDrugs = createAsyncThunk(
  "doctor/addDrugs",
  async ({ drug, selectedDrugs }, { dispatch, getState }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("/api/product/drug/create", drug);
      // dispatch(setSearchDrugs(response.data));
      const fetchedDrugs = response?.data;
      const currentDrugs = getState().product.drugList || [];
      // const retainedDrugs = currentDrugs.filter((drug) =>
      //   selectedDrugs.includes(drug.drugName)
      // );
      // console.log("retainedDrugs", retainedDrugs, "fetchedDrugs", fetchedDrugs);
      // const newDrugs = fetchedDrugs.filter(
      //   (drug) => !selectedDrugs.includes(drug.drugName)
      // );
      // console.log("newDrugs", newDrugs);
      const updatedDrugList = [...currentDrugs, fetchedDrugs];
      dispatch(setSearchDrugs(updatedDrugList));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      // toast.error("Somethng went wrong !! please try after some time..");
      dispatch(setError(error.toString()));
      return error;
    }
  }
);
export const fetchDrugList = createAsyncThunk(
  "product/fetchDrugList",
  async (page, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(`/api/product/drug/all?page=${page}`);
      dispatch(setDrugList(response?.data));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);
export const searchDrugList = createAsyncThunk(
  "product/searchDrugList",
  async ({ searchTerm, selectedDrugs }, { dispatch, getState }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/product/drug/all?search=${searchTerm}`
      );
      const fetchedDrugs = response?.data?.drugs;
      const currentDrugs = getState().product.drugList || [];
      const retainedDrugs = currentDrugs.filter((drug) =>
        selectedDrugs.includes(drug.drugName)
      );
      const updatedDrugList = [...retainedDrugs, ...fetchedDrugs];
      dispatch(setSearchDrugs(updatedDrugList));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);
export const deleteDrug = createAsyncThunk(
  "product/deleteDrug",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.delete(`/api/product/drug/${id}`);
      if (response.status === 200) {
        dispatch(deleteDrugs(id));
        dispatch(setLoading(false));
      }
      return response;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const createCustomProduct = createAsyncThunk(
  "doctor/createCustomProduct",
  async (productData, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("/api/doctor/custom-product", productData);
      toast.success("Custom product successfully added.");
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      const message = error.response?.data.error || "Failed to create custom product";
      toast.error(message);
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return rejectWithValue(
        error.response ? error.response.data : { message: "Unknown error occurred" }
      );
    }
  }
);

export const fetchCustomProducts = createAsyncThunk(
  "product/fetchCustomProducts",
  async ({ page = 1, limit = 10 } = {}, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/product/custom-products/all?page=${page}&limit=${limit}`
      );
      dispatch(setCustomProducts(response.data));
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
      return error;
    }
  }
);

export const linkCustomProductIID = createAsyncThunk(
  "product/linkCustomProductIID",
  async ({ id, IID }, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(`/api/product/link-iid/${id}`, { IID });
      toast.success("IID successfully linked.");
      dispatch(fetchCustomProducts()); // Refresh the list
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      toast.error(error.response?.data?.message || "Failed to link IID.");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const discontinueCustomProduct = createAsyncThunk(
  "product/discontinueCustomProduct",
  async ({ id, isDiscontinued }, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(`/api/product/discontinue/${id}`, { isDiscontinued });
      toast.success(`Product ${isDiscontinued ? "discontinued" : "activated"} successfully.`);
      dispatch(fetchCustomProducts());
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      toast.error(error.response?.data?.message || "Action failed.");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const verifyIIDAdmin = createAsyncThunk(
  "product/verifyIIDAdmin",
  async (IID, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(`/api/product/verify-iid/${IID}`);
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      toast.error(error.response?.data?.message || "Product not found.");
      throw error;
    }
  }
);

export const fetchTagsList = createAsyncThunk(
  "product/fetchTagsList",
  async (_, { dispatch }) => {
    try {
      const response = await apiAxios.get("/api/product/tags/all");
      if (response?.data?.tags) {
        dispatch(setTagsList(response.data.tags));
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching tags list:", error);
      return error;
    }
  }
);

export const createTag = createAsyncThunk(
  "product/createTag",
  async (tagData, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.post("/api/product/tags/create", tagData);
      toast.success(response.data.message || "Tag created successfully!");
      dispatch(fetchTagsList());
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to create tag.");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchDrugsListEnhanced = createAsyncThunk(
  "product/fetchDrugsListEnhanced",
  async (
    {
      page = 1,
      limit = 10,
      search = "",
      filter = "all",
      tagIds = "",
      sortBy = "drugName",
      sortOrder = "ASC",
    } = {},
    { dispatch }
  ) => {
    dispatch(setDrugManagementLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/product/drug/all?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}&filter=${filter}&tagIds=${tagIds}&sortBy=${sortBy}&sortOrder=${sortOrder}`
      );
      if (response?.data) {
        dispatch(setDrugManagementData(response.data));
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching drug list enhanced:", error);
      dispatch(setDrugManagementLoading(false));
      throw error;
    }
  }
);

export const fetchDrugProducts = createAsyncThunk(
  "product/fetchDrugProducts",
  async (drugId, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`/api/product/drug/${drugId}/products`);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || "Failed to fetch drug products";
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const createDrugEnhanced = createAsyncThunk(
  "product/createDrugEnhanced",
  async ({ drugName, tagIds }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.post("/api/product/drug/create", { drugName, tagIds });
      toast.success(`Drug "${response.data?.drugName}" created successfully!`);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || "Failed to create drug";
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateDrugEnhanced = createAsyncThunk(
  "product/updateDrugEnhanced",
  async ({ id, drugName, tagIds }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.patch(`/api/product/drug/update/${id}`, { drugName, tagIds });
      toast.success(response.data?.message || "Drug updated successfully!");
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || "Failed to update drug";
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteDrugEnhanced = createAsyncThunk(
  "product/deleteDrugEnhanced",
  async ({ id, unassignAll = false }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.delete(`/api/product/drug/${id}?unassignAll=${unassignAll}`);
      toast.success(response.data?.message || "Drug deleted successfully!");
      return response.data;
    } catch (error) {
      const data = error.response?.data;
      if (!data?.requiresUnassign) {
        toast.error(data?.error || "Failed to delete drug");
      }
      return rejectWithValue(data);
    }
  }
);

export const assignDrugToProducts = createAsyncThunk(
  "product/assignDrugToProducts",
  async ({ drugId, productIIDs }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(`/api/product/drug/${drugId}/assign`, { productIIDs });
      toast.success(response.data?.message || "Product(s) assigned successfully!");
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || "Failed to assign products";
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const unassignDrugFromProducts = createAsyncThunk(
  "product/unassignDrugFromProducts",
  async ({ drugId, productIIDs, unassignAll = false }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(`/api/product/drug/${drugId}/unassign`, { productIIDs, unassignAll });
      toast.success(response.data?.message || "Unassigned successfully!");
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || "Failed to unassign";
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const mergeDrugsThunk = createAsyncThunk(
  "product/mergeDrugsThunk",
  async ({ sourceDrugId, targetDrugId }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post("/api/product/drug/merge", { sourceDrugId, targetDrugId });
      toast.success(response.data?.message || "Drugs merged successfully!");
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || "Failed to merge drugs";
      toast.error(message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchNRxDrugs = createAsyncThunk(
  "product/fetchNRxDrugs",
  async (_, { dispatch }) => {
    try {
      const response = await apiAxios.get("/api/product/drug/nrx-drugs");
      if (response?.data?.nrxDrugNames) {
        dispatch(setNRxDrugNames(response.data.nrxDrugNames));
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching NRx drugs:", error);
      return error;
    }
  }
);

export const uploadProductImagesThunk = createAsyncThunk(
  "product/uploadImages",
  async (files, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      if (Array.isArray(files)) {
        files.forEach((file) => formData.append("images", file));
      } else {
        formData.append("images", files);
      }

      const response = await apiAxios.post("/api/product/upload-images", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response?.data?.imageUrls) {
        return response.data.imageUrls;
      }
      throw new Error("No image URLs returned");
    } catch (error) {
      const message = error?.response?.data?.error || error.message || "Failed to upload images";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const deleteProductImageThunk = createAsyncThunk(
  "product/deleteImage",
  async ({ url, productId }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.delete("/api/product/delete-image", {
        params: { url },
        data: { url, productId },
      });
      return response.data;
    } catch (error) {
      const message = error?.response?.data?.error || error.message || "Failed to delete image";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const fetchManufacturers = createAsyncThunk(
  "product/fetchManufacturers",
  async (params = {}, { dispatch, rejectWithValue }) => {
    try {
      const search = typeof params === "string" ? params : params?.search || "";
      const withCount = typeof params === "object" ? params?.withCount : false;
      const queryParams = new URLSearchParams();
      if (search) queryParams.append("search", search);
      if (withCount) queryParams.append("withCount", "true");

      const response = await apiAxios.get(
        `/api/product/manufacturers/all${queryParams.toString() ? `?${queryParams.toString()}` : ""}`
      );
      const manufacturers = response?.data?.manufacturers || [];
      dispatch(setManufacturersList(manufacturers));
      return manufacturers;
    } catch (error) {
      const message = error?.response?.data?.error || error.message || "Failed to fetch manufacturers";
      return rejectWithValue(message);
    }
  }
);

export const createManufacturerThunk = createAsyncThunk(
  "product/createManufacturer",
  async ({ name }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.post("/api/product/manufacturers/create", { name });
      const manufacturer = response?.data?.manufacturer;
      if (manufacturer) {
        dispatch(addManufacturer(manufacturer));
        toast.success(response?.data?.message || "Manufacturer added successfully");
      }
      return manufacturer;
    } catch (error) {
      const message = error?.response?.data?.error || error.message || "Failed to create manufacturer";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const updateManufacturerThunk = createAsyncThunk(
  "product/updateManufacturer",
  async ({ id, name, oldName }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.patch(`/api/product/manufacturers/${id}`, { name });
      const manufacturer = response?.data?.manufacturer;
      const count = response?.data?.productsUpdatedCount || 0;
      if (manufacturer) {
        dispatch(updateManufacturerInList({ id, name: manufacturer.name, oldName }));
        toast.success(
          count > 0
            ? `Manufacturer renamed! Updated in ${count} product(s).`
            : "Manufacturer updated successfully"
        );
      }
      return { manufacturer, productsUpdatedCount: count };
    } catch (error) {
      const message = error?.response?.data?.error || error.message || "Failed to update manufacturer";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const deleteManufacturerThunk = createAsyncThunk(
  "product/deleteManufacturer",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAxios.delete(`/api/product/manufacturers/${id}`);
      dispatch(removeManufacturerFromList(id));
      toast.success(response?.data?.message || "Manufacturer deleted successfully");
      return id;
    } catch (error) {
      const message = error?.response?.data?.error || error.message || "Failed to delete manufacturer";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const fetchManufacturerProductsThunk = createAsyncThunk(
  "product/fetchManufacturerProducts",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`/api/product/manufacturers/${id}/products`);
      return response?.data;
    } catch (error) {
      const message = error?.response?.data?.error || error.message || "Failed to fetch manufacturer products";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);



